import React from 'react';

export const Specification = ({ title, children }) => {
  return (
    <div className="specification">
      <h4>{title}</h4>
      <p>{children}</p>
    </div>
  );
}